import React, { useState } from "react";
import { useHistory } from "react-router";
import "dayjs/locale/es";
import { IonIcon } from "@ionic/react";

import {
  closeOutline,
  personOutline,
  timeOutline,
  calendarOutline,
  homeOutline,
  searchOutline,
  checkmarkCircleOutline,
} from "ionicons/icons";
import ModernDesplegable from "../../components/basicsComponents/ModernDesplegable/ModernDesplegable";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import { Card, Typography, Chip } from "@mui/joy";
import { LibraryAdd } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import { useHorariosPrestadores } from "./useHorariosPrestadores";

export default function HorariosPrestadores() {
  const history = useHistory();
  useTituloPagina();
  const [searchTerm, setSearchTerm] = useState("");

  // Consumir el hook centralizado
  const {
    cargando,
    setCargando,
    especialidades,
    setEspecialidades,
    especialidadSeleccionada,
    setEspecialidadSeleccionada,
    abrirDesplegableEspecialidades,
    setAbrirDesplegableEspecialidades,
    horario,
    setHorario,
    toast,
    setToast,
    handleChangeSelect,
    handleClickReservarTurnoPrestador,
  } = useHorariosPrestadores(
    (abrir, mensaje, tipo) => setToast({ open: abrir, mensaje, tipo }),
    history,
  );

  const handleVolverInicio = () => {
    history.push("/portal/Inicio");
  };

  // Función para obtener emoji según el día
  const getDayEmoji = (day) => {
    const emojis = {
      Lun: "📅",
      Mar: "📆",
      Mier: "📋",
      Jue: "🗓️",
      Vier: "📌",
      Sab: "⭐",
      Dom: "✨",
    };
    return emojis[day] || "📅";
  };

  // Filtrar horarios por búsqueda
  const horariosFiltrados = horario.filter((prestador) => {
    if (!searchTerm) return true;
    return prestador.prestadorNom
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
  });
  const ocultarSelectorEspecialidad = especialidades.length === 1;

  return (
    <>
      {/* HEADER CON TÍTULO Y BOTÓN VOLVER */}
      <div style={{ padding: "16px 16px 0 16px", backgroundColor: "#f8f9fa" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #3A3D99 0%, #fe506ca1 100%)",
            borderRadius: "16px",
            padding: "24px",
            marginBottom: "20px",
            boxShadow: "0 4px 20px rgba(58, 61, 153, 0.25)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                background: "rgba(255, 255, 255, 0.25)",
                borderRadius: "12px",
                padding: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: "blur(10px)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <IonIcon
                icon={timeOutline}
                style={{ fontSize: "28px", color: "white" }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "white",
                  textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                ⏰ Horarios de Atención
              </h1>
              <p
                style={{
                  margin: "4px 0 0 0",
                  color: "rgba(255, 255, 255, 0.9)",
                  fontSize: "14px",
                }}
              >
                {horario.length > 0
                  ? `${horario.length} prestador${horario.length !== 1 ? "es" : ""} disponible${horario.length !== 1 ? "s" : ""}`
                  : "Seleccione una especialidad para ver horarios"}
              </p>
            </div>
            <button
              onClick={handleVolverInicio}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 20px",
                backgroundColor: "white",
                border: "2px solid white",
                borderRadius: "12px",
                color: "#fe506ca1",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                position: "relative",
                zIndex: 2,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.color = "white";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.2)";
                e.currentTarget.style.backdropFilter = "blur(10px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "white";
                e.currentTarget.style.color = "#fe506ca1";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 8px rgba(0, 0, 0, 0.15)";
                e.currentTarget.style.backdropFilter = "none";
              }}
            >
              <IonIcon icon={homeOutline} style={{ fontSize: "18px" }} />
              <span>Volver al inicio</span>
            </button>
          </div>

          {!ocultarSelectorEspecialidad && (
            <div
              style={{
                background: "rgba(255, 255, 255, 0.15)",
                borderRadius: "12px",
                padding: "16px",
                backdropFilter: "blur(10px)",
              }}
            >
              <ModernDesplegable
                array={especialidades}
                value={especialidadSeleccionada}
                handleChange={handleChangeSelect}
                placeholder="Buscar especialidad..."
                label="Seleccione una especialidad"
                id="Especialidad"
                isOpen={abrirDesplegableEspecialidades}
                setIsOpen={setAbrirDesplegableEspecialidades}
                emoji="🏥"
                color="#fe506ca1"
              />
            </div>
          )}
        </div>

        {/* Barra de búsqueda de prestadores */}
        {horario.length > 0 && (
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "16px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <IonIcon
                icon={searchOutline}
                style={{ fontSize: "20px", color: "#fe506ca1" }}
              />
              <input
                type="text"
                placeholder="🔍 Buscar prestador por nombre..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  fontSize: "14px",
                  padding: "8px",
                  color: "#374151",
                }}
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    color: "#9ca3af",
                  }}
                >
                  <IonIcon icon={closeOutline} style={{ fontSize: "20px" }} />
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      {horario.length > 0 ? (
        <div
          style={{ padding: "0 16px 16px 16px", backgroundColor: "#f8f9fa" }}
        >
          <Row
            style={{ textAlign: "start" }}
            alignItems="stretch"
            container
            spacing={2}
          >
            {horariosFiltrados
              .filter(
                (prestador) =>
                  prestador.lunesM !== "" ||
                  prestador.lunesT !== "" ||
                  prestador.martesM !== "" ||
                  prestador.martesT !== "" ||
                  prestador.miercolesM !== "" ||
                  prestador.miercolesT !== "" ||
                  prestador.juevesM !== "" ||
                  prestador.juevesT !== "" ||
                  prestador.viernesM !== "" ||
                  prestador.viernesT !== "" ||
                  prestador.sabadoM !== "" ||
                  prestador.sabadoT !== "" ||
                  prestador.domingoM !== "" ||
                  prestador.domingoT !== "",
              )
              .map((prestador, i) => (
                <Column xs={12} md={6} xl={4} key={prestador.prestador}>
                  <Card
                    style={{
                      textAlign: "start",
                      padding: "20px",
                      borderRadius: "16px",
                      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
                      border: "1px solid rgba(102, 126, 234, 0.1)",
                      transition: "all 0.3s ease",
                      background:
                        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 24px rgba(102, 126, 234, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 16px rgba(0, 0, 0, 0.08)";
                    }}
                  >
                    {/* Header del Prestador */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "16px",
                        paddingBottom: "16px",
                        borderBottom: "2px solid rgba(254, 80, 108, 0.2)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          flex: 1,
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #3A3D99 0%, #fe506ca1 100%)",
                            borderRadius: "12px",
                            padding: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <IonIcon
                            icon={personOutline}
                            style={{ fontSize: "24px", color: "white" }}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Typography
                            level="title-lg"
                            sx={{
                              color: "#3A3D99",
                              fontWeight: "700",
                              fontSize: "16px",
                              marginBottom: "4px",
                            }}
                          >
                            👨‍⚕️ {prestador.prestadorNom}
                          </Typography>
                          <Chip
                            size="sm"
                            variant="soft"
                            color="primary"
                            startDecorator={
                              <IonIcon icon={checkmarkCircleOutline} />
                            }
                            sx={{ fontSize: "12px" }}
                          >
                            Disponible
                          </Chip>
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: "16px" }}>
                      <Typography
                        level="body-sm"
                        sx={{
                          fontWeight: "600",
                          color: "#6b7280",
                          marginBottom: "12px",
                        }}
                      >
                        📅 Horarios de atención:
                      </Typography>
                      <div style={{ display: "grid", gap: "8px" }}>
                        {[
                          {
                            day: "Lun",
                            m: prestador.lunesM,
                            t: prestador.lunesT,
                          },
                          {
                            day: "Mar",
                            m: prestador.martesM,
                            t: prestador.martesT,
                          },
                          {
                            day: "Mier",
                            m: prestador.miercolesM,
                            t: prestador.miercolesT,
                          },
                          {
                            day: "Jue",
                            m: prestador.juevesM,
                            t: prestador.juevesT,
                          },
                          {
                            day: "Vier",
                            m: prestador.viernesM,
                            t: prestador.viernesT,
                          },
                          {
                            day: "Sab",
                            m: prestador.sabadoM,
                            t: prestador.sabadoT,
                          },
                          {
                            day: "Dom",
                            m: prestador.domingoM,
                            t: prestador.domingoT,
                          },
                        ].map(({ day, m, t }) => {
                          const horario =
                            m === ""
                              ? t === ""
                                ? ""
                                : t
                              : m + (t === "" ? "" : " - " + t);

                          if (!horario) return null;

                          return (
                            <div
                              key={day}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "10px 12px",
                                background: "rgba(58, 61, 153, 0.05)",
                                borderRadius: "8px",
                                border: "1px solid rgba(254, 80, 108, 0.2)",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "700",
                                  color: "#fe506ca1",
                                  minWidth: "50px",
                                  fontSize: "13px",
                                }}
                              >
                                {getDayEmoji(day)} {day}:
                              </span>
                              <span
                                style={{
                                  color: "#374151",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                }}
                              >
                                ⏰ {horario}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* Botón Reservar Turno */}
                    <button
                      onClick={() =>
                        handleClickReservarTurnoPrestador(prestador.prestador)
                      }
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        padding: "14px",
                        background:
                          "linear-gradient(135deg, #3A3D99 0%, #fe506ca1 100%)",
                        border: "none",
                        borderRadius: "12px",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 12px rgba(58, 61, 153, 0.25)",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow =
                          "0 6px 16px rgba(254, 80, 108, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(58, 61, 153, 0.25)";
                      }}
                    >
                      <IonIcon
                        icon={calendarOutline}
                        style={{ fontSize: "18px" }}
                      />
                      <span>RESERVAR TURNO</span>
                      <LibraryAdd style={{ fontSize: "18px" }} />
                    </button>
                  </Card>
                </Column>
              ))}
          </Row>

          {horariosFiltrados.length === 0 && searchTerm && (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                background: "white",
                borderRadius: "12px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
              }}
            >
              <IonIcon
                icon={searchOutline}
                style={{
                  fontSize: "48px",
                  color: "#d1d5db",
                  marginBottom: "16px",
                }}
              />
              <Typography
                level="h4"
                sx={{ color: "#6b7280", marginBottom: "8px" }}
              >
                No se encontraron prestadores
              </Typography>
              <Typography level="body-sm" sx={{ color: "#9ca3af" }}>
                No hay prestadores que coincidan con "{searchTerm}"
              </Typography>
            </div>
          )}
        </div>
      ) : (
        especialidadSeleccionada !== -1 &&
        !cargando && (
          <div
            style={{ padding: "0 16px 16px 16px", backgroundColor: "#f8f9fa" }}
          >
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
                background: "white",
                borderRadius: "16px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
              }}
            >
              <IonIcon
                icon={timeOutline}
                style={{
                  fontSize: "64px",
                  color: "#d1d5db",
                  marginBottom: "16px",
                }}
              />
              <Typography
                level="h3"
                sx={{ color: "#6b7280", marginBottom: "8px" }}
              >
                😔 Sin horarios disponibles
              </Typography>
              <Typography level="body-md" sx={{ color: "#9ca3af" }}>
                No hay prestadores con horarios disponibles para esta
                especialidad
              </Typography>
            </div>
          </div>
        )
      )}

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => setToast({ open: false, mensaje: "", tipo: "" })}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
